import React from 'react';
import SVG from 'react-inlinesvg';
import Button, { Color as ButtonColor, Size, TextOverflow, TextSize } from 'lib/Button';
import Chip from 'lib/Chip';
import { Color as ChipColor } from 'lib/Chip/Chip.types';
import chevronRight from 'assets/icons/chevron_right.svg';
import excludeSvg from 'assets/icons/exclude.svg';
import includeSvg from 'assets/icons/include.svg';
import { NavigationButtonProps } from './NavigationButton.types';

const NavigationButton: React.FC<NavigationButtonProps> = ({
  buttonLabel,
  buttonIcon,
  onClick,
  targetValue,
  includedFilters,
  excludedFilters,
  isDisabled = false,
}) => {
  return (
    <Button
      label={buttonLabel}
      onClick={onClick}
      size={Size.WIDE}
      color={ButtonColor.BLACK_AND_WHITE}
      svg={buttonIcon}
      classNames="flex justify-between items-center p-1 shadow-inner-sm"
      svgClassnames="w-4 h-4"
      textSize={TextSize.SMALL}
      textOverflow={TextOverflow.VISIBLE}
      isDisabled={isDisabled}
    >
      <div className="flex justify-end items-center flex-1 gap-x-1">
        {targetValue ? <Chip icon={includeSvg} label={targetValue} /> : null}
        {excludedFilters ? <Chip icon={excludeSvg} label={excludedFilters.toString()} color={ChipColor.GREY} /> : null}
        {includedFilters ? <Chip icon={includeSvg} label={includedFilters.toString()} color={ChipColor.GREEN} /> : null}
        <SVG src={chevronRight} className="w-4 h-4 text-neutral-600" />
      </div>
    </Button>
  );
};

export default NavigationButton;
